import {
  Box,
  Button,
  Grid,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import "./AvatarCreation.css";
import FemaleBase from "../../images/avatarAssets/female-base.png";
import FemaleEyeDeep from "../../images/avatarAssets/female-eyes_deep-set.png";
import FemaleEyeMono from "../../images/avatarAssets/female-eyes_monolid.png";
import FemaleEyeRound from "../../images/avatarAssets/female-eyes_round.png";
import FemaleHairLongWavy from "../../images/avatarAssets/female-hair_long-wavy.png";
import FemaleHairShortStraight from "../../images/avatarAssets/female-hair_short-straight.png";
import FemaleHairShortWavy from "../../images/avatarAssets/female-hair_short-wavy.png";
import MaleBase from "../../images/avatarAssets/male-base.png";
import MaleEyeDeep from "../../images/avatarAssets/male-eyes_deep-set.png";
import MaleEyeMono from "../../images/avatarAssets/male-eyes_monolid.png";
import MaleEyeRound from "../../images/avatarAssets/male-eyes_round.png";
import MaleHairShort from "../../images/avatarAssets/male-hair_short.png";
import MaleHairStyled from "../../images/avatarAssets/male-hair_styled.png";
import MaleHairWavy from "../../images/avatarAssets/male-hair_wavy.png";
import MouthNeutral from "../../images/avatarAssets/neutral.png";
import MouthShy from "../../images/avatarAssets/shy-smile.png";
import MouthSmile from "../../images/avatarAssets/wide-smile.png";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import ImageStack from "./imageStack/ImageStack";
import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import ImageDownload from "./imageDownload/ImageDownload";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";

function AvatarCreation() {
  const [name, setName] = useState("______");
  const [age, setAge] = useState("__");
  const [job, setJob] = useState("______");
  const { productClass, answers } = useSelector((state) => state.fPage);
  const [selectedBase, setSelectedBase] = useState(FemaleBase);
  const [selectedHair, setSelectedHair] = useState();
  const [selectedEyes, setSelectedEyes] = useState();
  const [selectedMouth, setSelectedMouth] = useState();
  const selectedImages = [
    selectedBase,
    selectedHair,
    selectedEyes,
    selectedMouth,
  ];
  const [hidden, setHidden] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!productClass || !answers) {
      navigate("/");
    }
  }, []);

  const handleBase = (event, select) => {
    if (select !== null) {
      setSelectedBase(select);
      setSelectedEyes();
      setSelectedHair();
      setSelectedMouth();
    }
  };

  const handleHair = (event, select) => {
    if (select !== null) {
      setSelectedHair(select);
    }
  };

  const handleEyes = (event, select) => {
    if (select !== null) {
      setSelectedEyes(select);
    }
  };

  const handleMouth = (event, select) => {
    if (select !== null) {
      setSelectedMouth(select);
    }
  };

  const handleTools = () => {
    window.location.replace("https://aralplus.ph/quick-learning-tools");
  };

  const handleChoice = () => {
    window.location.replace("https://aralplus.ph/choice-module");
  };

  const handleVids = () => {
    window.location.replace("https://aralplus.ph");
  };

  const handleSave = () => {
    if (name === "______" || age === "__" || job === "______") {
      Swal.fire({
        icon: "error",
        title: "Incomplete Fields",
        text: "Please complete all required fields to proceed",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      return;
    }

    if (!selectedEyes || !selectedHair || !selectedMouth) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Template",
        text: "Please complete all template selections",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      return;
    }
    setHidden(false);

    setTimeout(() => {
      const component = document.querySelector(".toDownload"); // Update with the appropriate selector

      html2canvas(component)
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          handleDownload(imgData); // Automatically trigger the download after capture
          setHidden(true);
        })
        .catch((error) => {
          console.error("Error capturing ImageDownload:", error);
        });
    }, 500);
  };

  const handleDownload = (imageData) => {
    const a = document.createElement("a");
    a.href = imageData;
    a.download = "My Avatar.png";
    a.click();
  };

  return (
    <Box className="main-avatar-card">
      <Grid container>
        <Grid item xs={12}>
          <h1 style={{ fontSize: "2.5rem" }}>
            Avatar Making Matched to Your Financial Goal and Plan
          </h1>
        </Grid>
        <Grid item xs={12} md={4} className="grid-item">
          <Box className="avatar-select-card">
            <Box className="avatar-select-container-card">
              <TextField
                className="textfield"
                placeholder="Name"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                }}
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                className="textfield"
                placeholder="Occupation"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                }}
                onChange={(e) => setJob(e.target.value)}
              />
              <TextField
                className="textfield"
                placeholder="Age"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                }}
                onChange={(e) => setAge(e.target.value)}
                type="number"
              />
              <Box>
                <h4>Choose face template</h4>
                <Box className="button-container">
                  <ToggleButtonGroup
                    value={selectedBase}
                    exclusive
                    onChange={handleBase}
                    fullWidth
                  >
                    <ToggleButton value={FemaleBase} className="root">
                      <img src={FemaleBase} alt="base" className="img-root" />
                    </ToggleButton>
                    <ToggleButton value={MaleBase} className="root">
                      <img src={MaleBase} alt="base" className="img-root" />
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </Box>
              <Box>
                <h4>Choose hair template</h4>
                <Box className="button-container">
                  {selectedBase === FemaleBase && (
                    <ToggleButtonGroup
                      value={selectedHair}
                      exclusive
                      onChange={handleHair}
                    >
                      <ToggleButton value={FemaleHairLongWavy} className="root">
                        <img
                          src={FemaleHairLongWavy}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                      <ToggleButton
                        value={FemaleHairShortStraight}
                        className="root"
                      >
                        <img
                          src={FemaleHairShortStraight}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                      <ToggleButton
                        value={FemaleHairShortWavy}
                        className="root"
                      >
                        <img
                          src={FemaleHairShortWavy}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  )}
                  {selectedBase === MaleBase && (
                    <ToggleButtonGroup
                      value={selectedHair}
                      exclusive
                      onChange={handleHair}
                    >
                      <ToggleButton value={MaleHairShort} className="root">
                        <img
                          src={MaleHairShort}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                      <ToggleButton value={MaleHairStyled} className="root">
                        <img
                          src={MaleHairStyled}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                      <ToggleButton value={MaleHairWavy} className="root">
                        <img
                          src={MaleHairWavy}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  )}
                </Box>
              </Box>
              <Box>
                <h4>Choose eye template</h4>
                <Box className="button-container">
                  {selectedBase === FemaleBase && (
                    <ToggleButtonGroup
                      value={selectedEyes}
                      exclusive
                      onChange={handleEyes}
                    >
                      <ToggleButton value={FemaleEyeDeep} className="root">
                        <img
                          src={FemaleEyeDeep}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                      <ToggleButton value={FemaleEyeMono} className="root">
                        <img
                          src={FemaleEyeMono}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                      <ToggleButton value={FemaleEyeRound} className="root">
                        <img
                          src={FemaleEyeRound}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  )}
                  {selectedBase === MaleBase && (
                    <ToggleButtonGroup
                      value={selectedEyes}
                      exclusive
                      onChange={handleEyes}
                    >
                      <ToggleButton value={MaleEyeDeep} className="root">
                        <img
                          src={MaleEyeDeep}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                      <ToggleButton value={MaleEyeMono} className="root">
                        <img
                          src={MaleEyeMono}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                      <ToggleButton value={MaleEyeRound} className="root">
                        <img
                          src={MaleEyeRound}
                          alt="base"
                          className="img-root"
                        />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  )}
                </Box>
              </Box>
              <Box>
                <h4>Choose nose and mouth template</h4>
                <Box className="button-container">
                  <ToggleButtonGroup
                    value={selectedMouth}
                    exclusive
                    onChange={handleMouth}
                  >
                    <ToggleButton value={MouthNeutral} className="root">
                      <img src={MouthNeutral} alt="base" className="img-root" />
                    </ToggleButton>
                    <ToggleButton value={MouthShy} className="root">
                      <img src={MouthShy} alt="base" className="img-root" />
                    </ToggleButton>
                    <ToggleButton value={MouthSmile} className="root">
                      <img src={MouthSmile} alt="base" className="img-root" />
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={4} className="grid-item">
          <ImageStack images={selectedImages} />
        </Grid>
        <Grid item xs={12} md={4} className="grid-item" flexDirection="column">
          <Box className="bubble-container">
            <Box className="bubble-text">
              {productClass === "savings" && (
                <>
                  Kumusta? Ako si {name}, edad {age}, na nagtatrabaho bilang
                  isang {job}. Ang pangarap ko para sa aking buhay pinansyal ay{" "}
                  {answers.mainQuestion}.
                  <br />
                  <br />
                  Upang makamit ko ang aking financial goals, ang produkto o
                  serbisyo na makakatulong sa akin ay savings.
                  <br />
                  <br />
                  Ang kabuuang halaga na gusto kong pag-ipunan ay{" "}
                  {answers.savingsQ1} pesos.
                  <br />
                  <br />
                  Ang kaya ko namang maipon kada buwan ay halagang{" "}
                  {answers.savingsQ2} pesos.
                </>
              )}
              {productClass === "loan" && (
                <>
                  Kumusta? Ako si {name}, edad {age}, na nagtatrabaho bilang
                  isang {job}. Ang pangarap ko para sa aking buhay pinansyal ay{" "}
                  {answers.mainQuestion}.
                  <br />
                  <br />
                  Upang makamit ko ang aking financial goals, ang produkto o
                  serbisyo na makakatulong sa akin ay loan.
                  <br />
                  <br />
                  Nais kong kumuha ng loan para sa {answers.loanQ1}.
                  <br />
                  <br />
                  Gusto kong makakuha ng loan na nagkakahalaga ng{" "}
                  {answers.loanQ2} pesos.
                  <br />
                  <br />
                  Sa aking palagay ay mababayaran ko ito sa loob ng{" "}
                  {answers.loanQ3}.
                </>
              )}
              {productClass === "insurance" && (
                <>
                  Kumusta? Ako si {name}, edad {age}, na nagtatrabaho bilang
                  isang {job}. Ang pangarap ko para sa aking buhay pinansyal ay{" "}
                  {answers.mainQuestion}.
                  <br />
                  <br />
                  Upang makamit ko ang aking financial goals, ang produkto o
                  serbisyo na makakatulong sa akin ay insurance.
                  <br />
                  <br />
                  {answers.insuranceQ1} ang klase ng insurance na nais kong
                  makuha.
                  <br />
                  <br />
                  Sa aking palagay ay kaya kong makapagbigay ng premium para sa
                  insurance sa halagang {answers.insuranceQ2} pesos.
                </>
              )}
              {productClass === "others" && (
                <>
                  Kumusta? Ako si {name}, edad {age}, na nagtatrabaho bilang
                  isang {job}. Ang pangarap ko para sa aking buhay pinansyal ay{" "}
                  {answers.mainQuestion}.
                  <br />
                  <br />
                  Upang makamit ko ang aking financial goals, ang produkto o
                  serbisyo na makakatulong sa akin ay {answers.otherQ1}.
                </>
              )}
            </Box>
          </Box>
          <Button className="save-button" onClick={() => handleSave()}>
            Save Avatar
          </Button>
          <Box className="scroll-text">
            <KeyboardDoubleArrowDown
              sx={{ fontSize: 40, marginRight: ".5rem" }}
            />{" "}
            <p> Scroll down for more</p>
          </Box>
        </Grid>
        <Grid item xs={12} className="grid-item" flexDirection="column">
          <Box className="footer-container">
            <p className="footer-text" style={{ width: "600px" }}>
              Check out the following to help you improve your empowerment level
              in the Choice dimensions:
            </p>
          </Box>
          <Box className="footer-container-2">
            <p className="link-text" onClick={() => handleChoice()}>
              Choice Module
            </p>
          </Box>
          <Box className="footer-container-2">
            <p className="link-text" onClick={() => handleVids()}>
              Videos of an Empowered Filipino Customer
            </p>
          </Box>
          <Box className="footer-container-2" sx={{ marginBottom: "5rem" }}>
            <p className="link-text" onClick={() => handleTools()}>
              Other Quick Learning Tools
            </p>
          </Box>
        </Grid>
        {hidden === false && (
          <Grid item xs={12}>
            <div className="toDownload" style={{ width: "100%" }}>
              <ImageDownload
                images={selectedImages}
                name={name}
                age={age}
                job={job}
              />
            </div>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default AvatarCreation;
